<template>
  <div class="college-intro">
    <website-header :setNum="2"></website-header>
    <div class="index-top" :style="`background-image:url('${imgURI + '/static/college/Intro/dianshangxueyuanbeijng.png'}');`">
      <!--      <div class="index-top-bor">-->
      <!--        <div class="display-flex tips-c">侃侃 让世界更懂你！</div>-->
      <!--        <div class="display-flex flex-column tips">-->
      <!--          <div class="bold">MAKE THE WORLD</div>-->
      <!--          <div class="font-weight-100">UNDERSTAND YOU BETTER</div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="college-intro-content">
      <div class="msg-bor def-width margin-center">
        <div class="msg-bor-left" id="profile">
          <tips :tipsC="`学院简介`" :tipsE="`COLLEGE PROFILE`" :paddingTop="20"></tips>
          <div class="msg color-979797">
            电商学院深耕跨境电商行业，形成一套完整的集调研、体验、合作、分享为一体的多元化服务体系，为所有项目客户建立个人信息库，设立专业咨询顾问服务团队，全程跟进客户体验及反馈，第一时间解决客户在运营过程中遇到的问题。
          </div>
        </div>
        <div class="intro-carousel">
          <img :src="`${imgURI}/static/college/Intro/xueyuanjianjietu.png`">
<!--          <el-carousel indicator-position="none" :interval="4000" height="350px">-->
<!--            <el-carousel-item>-->
<!--              <img :src="`${imgURI}/static/college/Intro/TU1.png`" class="aveter"/>-->
<!--            </el-carousel-item>-->
<!--            <el-carousel-item>-->
<!--              <img :src="`${imgURI}/static/college/Intro/TU1_1.png`" class="aveter"/>-->
<!--            </el-carousel-item>-->
<!--            <el-carousel-item>-->
<!--              <img :src="`${imgURI}/static/college/Intro/TU1_2.png`" class="aveter"/>-->
<!--            </el-carousel-item>-->
<!--          </el-carousel>-->
        </div>
      </div>
      <div class="college-intro-other-bor">
        <div class="college-intro-other">
          <div class="intro-other">
            <div class="intro-other-carousel">
              <img :src="`${imgURI}/static/college/Intro/tu22.png`">
<!--              <el-carousel indicator-position="none" :interval="4000" height="228px">-->
<!--                <el-carousel-item>-->
<!--                  <img :src="`${imgURI}/static/college/Intro/TU2.png`" class="aveter"/>-->
<!--                </el-carousel-item>-->
<!--                <el-carousel-item>-->
<!--                  <img :src="`${imgURI}/static/college/Intro/TU2_1.png`" class="aveter"/>-->
<!--                </el-carousel-item>-->
<!--                <el-carousel-item>-->
<!--                  <img :src="`${imgURI}/static/college/Intro/TU2_2.png`" class="aveter"/>-->
<!--                </el-carousel-item>-->
<!--              </el-carousel>-->
            </div>
            <div class="intro-other-content">
              学院课程涵盖运营、管理、财务以及企业内训等服务。课程涵盖SEO、PPC、站外引流、数据选品、自建站、Tiktok、全流程爆款打造、企业薪酬与绩效管理、财税、轻孵化、账号安全防控申诉、产品设计研发管理及供应链管理等多个领域，为卖家打造一站式的知识内容服务平台。
            </div>
          </div>

          <div class="intro-other">
              <div class="intro-other-carousel">
                <img :src="`${imgURI}/static/college/Intro/xyjj2.png`">
<!--                  <el-carousel indicator-position="none" :interval="4000" height="228px">-->
<!--                    <el-carousel-item>-->
<!--                      <img :src="`${imgURI}/static/college/Intro/TU3.png`" class="aveter"/>-->
<!--                    </el-carousel-item>-->
<!--                    <el-carousel-item>-->
<!--                      <img :src="`${imgURI}/static/college/Intro/TU3_1.png`" class="aveter"/>-->
<!--                    </el-carousel-item>-->
<!--                    <el-carousel-item>-->
<!--                      <img :src="`${imgURI}/static/college/Intro/TU3_2.png`" class="aveter"/>-->
<!--                    </el-carousel-item>-->
<!--                  </el-carousel>-->
              </div>
            <div class="intro-other-content">
              学院由侃侃、白鹿会创始人MOSS与一众跨境行业领域大咖组成的师资团队，长期与Amazon、eBay、Wish、shopee、AliExpress、shopify等平台保持密切合作。学院凭借扎实的运营水平、细致的服务、全新学习型的团队，用丰富的行业资源与实力为客户提供更专业的支持与服务、愈发全面与前沿的培训内容和软件技术等产品。学院在服务过程中，与国内外众多知名跨境电商企业建立了良好、稳固的合作伙伴关系逐步形成强大的人才、技术和品牌优势。
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="college-title text-center">从业务场景出发</div>
        <div class="college-content color-979797 font-12 text-center">
          能够覆盖电商企业从前期入驻，到平台运营，广告业务等各真实业务场景。<br/>
          能够真正帮助企业梳理完整经营链路，做到“节点式”、“模块化”业务能力重点提升。<br/>
          可帮助企业完成在行业中的业务发展，及行业增长。
        </div>
        <img class="college-content-img" :src="`${imgURI}/static/college/Intro/tu4.png`">
      </div>
      <div>
        <div class="college-title text-center" style="margin-bottom: 14px;margin-top: 100px">从人才场景出发</div>
        <div class="college-content color-979797 font-12 text-center">
          能够囊括了电商人从入行学习，各个岗位能力储备，以及后期的电商企业管理能力提升，<br/>
          陪伴了电商人终生的学习和成长，也帮助企业进行了各个岗位专业胜任力模型的打造，也可以完成高潜人才的储备和培养。
        </div>
        <img class="college-content-img" style="margin-top: 50px" :src="`${imgURI}/static/college/Intro/tu5.png`">
      </div>
      <div class="college-content-other text-center color-979797">
        培训的最终目标，是实现“知识一技能一行为一业绩”的转化，通常这一转化过程会出现“自然衰减”侃侃电商学院是以业务为出发点、<br/>
        以场景作为学习背景的全新学习方式，通过一系列学习活动让学员把学习知识、训练技能、改变行为和产出绩效有效连接起来。<br/>
        业务的问题是多元的、企业的资源是有限的，侃侃认为找到“对”的关键业务场景，<br/>
        基于该关键场景通过“对”的关键人才以“对”的方式去落地解决是最高效的学习模式，据此推出了覆盖电商企业运营全业务场景的课程矩阵体系。
      </div>
      <div id="advantage">
        <div>
          <div class="website-index-tips text-center">
            <span class="tips-about bold color-1E1E1E">COLLEGE ADVANTAGE</span>
          </div>
          <div class="website-index-tips-c text-center color-1E1E1E">学院优势<span class="tips-block"></span></div>
        </div>
        <div class="team-bg" :style="`background-image:url('${imgURI + '/static/college/Intro/65.png'}');`">
          <div class="team-bor">
            <img class="team-img" :src="`${imgURI}/static/college/Intro/shiziqiangda.png`">
          </div>
          <ul class="display-flex justify-content-center team-user">
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/moss.png`">
            </li>
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/linweixiong.png`">
            </li>
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/george.png`">
            </li>
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/Davie.png`">
            </li>
          </ul>
          <ul class="display-flex justify-content-center team-user">
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/Pharaoh.png`">
            </li>
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/Mike.png`">
            </li>
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/Nami.png`">
            </li>
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/chenshaochuan.png`">
            </li>
          </ul>
          <ul class="display-flex justify-content-center team-user">
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/huangxuefeng.png`">
            </li>
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/renjiawei.png`">
            </li>
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/wanghaolin.png`">
            </li>
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/Gary.png`">
            </li>
          </ul>
          <ul class="display-flex justify-content-center team-user">
            <li>
              <img class="team-user-img" :src="`${imgURI}/static/college/Intro/guoxuhua.png`">
            </li>
          </ul>
        </div>
      </div>
      <div class="curriculum-bor">
        <tips :tipsC="`课程丰富`" :tipsE="`RICH CURRICULUM`" :paddingTop="20"></tips>
      </div>
      <img style="width: 100%" :src="`${imgURI}/static/college/Intro/kechengfengfu.png`">
      <div class="rich-code display-flex justify-content-end text-center">
        <div class="img-bor">
          <img :src="`${imgURI}/static/college/advantages/erweima1.png`">
          <div class="rich-code-title">讲师合作</div>
        </div>
        <div class="img-bor">
          <img :src="`${imgURI}/static/college/advantages/erweima2.png`">
          <div class="rich-code-title">课程咨询</div>
        </div>
      </div>
      <div>
        <img class="strict" :src="`${imgURI}/static/college/Intro/nryx.png`">
      </div>
      <div class="operations-services">
        <tips :tipsC="`运营服务`" :tipsE="`OPERATIONS SERVICES`" :paddingTop="20"></tips>
        <ul class="operations display-flex justify-content-center text-center margin-center">
          <li>
            <img :src="`${imgURI}/static/college/Intro/tubiao.png`">
            <div class="title">客户为导向 、专业运营团队</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/Intro/tubiao1.png`">
            <div class="title">一对一销售咨询、答疑、售后</div>
          </li>
          <li>
            <img :src="`${imgURI}/static/college/Intro/tubiao2.png`">
            <div class="title">7x24小时客户服务</div>
          </li>
        </ul>
      </div>
    </div>
    <website-bot></website-bot>
  </div>
</template>

<script>
import WebsiteBot from '@/components/public/websiteBot'
import WebsiteHeader from '@/components/public/header'
import config from '@/config/index'
import tips from '@/components/public/tips'

export default {
  name: "collegeIntro",
  components: {WebsiteBot, WebsiteHeader, tips},
  data () {
    return {
      imgURI: config.imgURI
    }
  },
  mounted () {
    if (this.$route.query.id) {
      this.goAnchor(this.$route.query.id)
    }
  },
  watch: {
    // 监听路由对象$route的变化
    '$route': {
      handler: function (to, from) {
        if (to) {
          this.goAnchor(to.query.id)
        }
      },
      deep: true
    }
  },
  methods: {
    goAnchor (id) {
      document.querySelector(`#${id}`).scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.college-intro{
  .index-top{
    margin-top: -100px;
    width: 100%;
    height: 750px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .index-top-bor{
      padding-top: 180px;
      margin: 0 auto;
      width: 1200px;
    }
    .tips{
      font-size: 25px;
      color: #ffffff;
    }
    .tips-c{
      letter-spacing: 8px;
      font-size: 48px;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .college-intro-content{
    padding-bottom: 156px;
    width: 100%;
    //background-image: url("/static/college/Intro/diwen1.png");
    //background-repeat: no-repeat;
    //background-size: 100% 100%;
    .msg-bor{
      padding-top: 148px;
      .msg-bor-left{

        box-shadow: 0 0 10px #eaeaea;
        float: left;
        padding: 0 40px;
        width: 577px !important;
        height: 307px;
        background: #FFFFFF;
        position: relative;
        z-index: 2;
      }
    }
    .line{
      margin-bottom: 14px;
      width: 16px;
      height: 16px;
      background: #386BF3;
      border-radius: 2px 2px 2px 2px;
    }
    .intro-carousel{
      margin-top: -326px;
      width: 715px;
      float: right;
      z-index: 1;
    }
    .msg{
      margin-top: 20px;
      letter-spacing: 0.5px;
      font-size: 12px;
      line-height: 26px;
    }
  }
  .college-intro-other-bor{
    margin-top: 382px;
    padding: 51px 0 20px 0;
    background: #F7FAFD;
    .college-intro-other{
      margin: 0 auto;
      width: 1200px;
      display: flex;
      justify-content: space-between;
      gap: 20px;
      .intro-other{
        width: 591px;
        height: 453px;
        background: #FFFFFF;
        box-shadow: 0 6px 10px #eaeaea;
        .intro-other-carousel{
          width: 100%;
        }
        .intro-other-content{
          padding: 50px 20px 0 20px;
          font-size: 12px;
          color: #979797;
          line-height: 24px;
        }
      }
    }
  }
}

.aveter{
  width: 100%;
  height: 100%;
}
.college-title{
  margin: 152px auto 30px auto;
  color: #3696E8;
  font-weight: bold;
  font-size: 24px;
}
.college-content{
  line-height: 24px;
  letter-spacing: 1px;
}
.college-content-img{
  margin-top: 30px;
  width: 100%;
}
.college-content-other{
  margin-top: 90px;
  margin-bottom: 50px;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 1px;
}
.website-index-tips{
  padding: 89px 0 0 0;
}
.website-index-tips-c{
  padding-bottom: 60px;
  font-size: 24px;
}
.tips-about{
  letter-spacing: 2px;
  font-size: 25px;
}
.tips-block{
  position: relative;
  top: 2px;
  margin-left: 6px;
  display: inline-block;
  width: 12px;
  height: 12px;
  background: #0685D9;
  border-radius: 2px 2px 2px 2px;
}
.team-bg{
  height: 1340px;
  //background-image: url("/static/college/Intro/65.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .team-user{
    margin-top: 24px;
    gap: 50px;
    .team-user-img{
      width: 204px;
      height: 261px;
    }
  }
}
.team-bor{
  width: 1200px;
  margin: 0 auto;
  .team-img{
    margin-top: 35px;
  }
}
.curriculum-bor{
  width: 1200px;
  margin: 130px auto 0 auto;
}
.rich-code{
  margin-top: 40px;
  width: 1200px;
  gap: 10px;
  .img-bor{
    width: 92px;
  }
  .rich-code-title{
    font-size: 12px;
    background: #000000;
    color: #FFFFFF;
  }
  img{
    position: relative;
    left: -3px;
    //padding: 2px;
    width: 98px;
    //border: 1px solid #707070;
  }
}
.strict{
  margin-top: 150px;
  width: 100%;
}
.operations-services{
  width: 970px;
  margin: 150px auto 0 auto;
  .operations{
    margin-top: 60px;
    gap: 60px;
    li{
      text-align: center;
      width: 240px;
      img{
        width: 80px;
      }
      .title{
        font-size: 18px;
        margin-top: 28px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/college/Intro.vue